 
import format from '_shared_/plugins/format';

const mutations = {
  SET_RETURNS(state, payload) {
    try {
      const monthly = payload.returns.monthly || {};
      const quarterly = payload.returns.quarterly || {};
      const annualReturns = payload.annualReturns || {};
      state.returns = {
        monthly: {
          asOfDate: format.formatHelpers.shortDate(monthly.AsOfData),
          chart: payload.charts.monthly.chart,
          cgIndexID: monthly.CGIndexID,
          cgIndexName: monthly.CGIndexName
        },
        quarterly: {
          asOfDate: format.formatHelpers.shortDate(quarterly.AsOfData),
          chart: payload.charts.quarterly.chart,
          cgIndexID: quarterly.CGIndexID,
          cgIndexName: quarterly.CGIndexName?.length ? quarterly.CGIndexName : monthly.CGIndexName
        },
        valuation: {
          mstarPriceToBook: payload.valuation.MStarPriceToBook,
          mstarPriceToCash: payload.valuation.MStarPriceToCash,
          mstarPriceToEarnings: payload.valuation.MStarPriceToEarnings,
          mstarPortfolioDate: payload.valuation.MStarPortfolioDate,
          cgIndexID: payload.valuation.CGIndexID,
          cgIndexName: format.formatHelpers.name(payload.valuation.CGIndexName),
          indexPriceToBook: payload.valuation.IndexPriceToBook,
          indexPriceToCash: payload.valuation.IndexPriceToCash,
          indexPriceToEarnings: payload.valuation.IndexPriceToEarnings,
          indexPortfolioDate: payload.valuation.IndexPortfolioDate
        },
        yield: {
          distributionRateDate: payload.yield.DistributionRateDate,
          distributionRateNAV: payload.yield.DistributionRateNAV,
          secYield30DayNet: payload.yield.SecYield30DayNet,
          secYield30DayNetDate: payload.yield.SecYield30DayNetDate,
          secYield30DayGross: payload.yield.secYield30DayGross,
          secYield30DayGrossDate: payload.yield.secYield30DayGrossDate
        },
        annualReturns: {
          inceptionDate: annualReturns.inceptionDate,
          maxDate: annualReturns.maxDate
        }
      };
      state.annualReturnsLargeChart = payload.charts.largeChart;
      state.annualReturnsLargeChartData = payload.charts.largeChartData;
      state.annualReturnsLargeChartNav = payload.charts.largeChartNav;
      state.annualReturnsLargeChartNavData = payload.charts.largeChartDataNav;
    } catch (err) {
      console.error('error in "SET_RETURNS" mutation: ', err);  
    }
  }
};

const getters = {
  getReturns: state => state.returns || {},
  getValuation: state => state.returns && state.returns.valuation || {},
  getYield: state => state.returns && state.returns.yield || {},
  getReturnsLargeChart: state => state.annualReturnsLargeChart || '',
  getReturnsLargeChartData: state => state.annualReturnsLargeChartData || {},
  getReturnsLargeChartNav: state => state.annualReturnsLargeChartNav || '',
  getReturnsLargeChartNavData: state => state.annualReturnsLargeChartNavData || {},
  getAnnualReturnsData: state => state.returns && state.returns.annualReturns || {}
};

const state = {
  returns: null,
  annualReturnsLargeChart: null,
  annualReturnsLargeChartData: null,
  annualReturnsLargeChartNav: null,
  annualReturnsLargeChartNavData: null
};

export default {
  state,
  getters,
  mutations
};
